import React from "react";

// import assets
import hbGuideBanner from "../../../assets/banner/construction_road_map_bg_pic.jpg";

// import components
import HbGuideForm from "./HbGuideForm";

// import styled components
import { HbGuideContainer, HbGuideWrapper } from "./styled";

function HbGuide({ account, name }) {
  let bannerToShow;

  if (window.outerWidth) {
    if (window.outerWidth >= 992) {
      bannerToShow = hbGuideBanner;
    } else {
      bannerToShow = hbGuideBanner;
    }
  } else {
    if (document.body.clientWidth >= 992) {
      bannerToShow = hbGuideBanner;
    } else {
      bannerToShow = hbGuideBanner;
    }
  }

  return (
    <HbGuideWrapper
      style={{
        backgroundImage: `url(${bannerToShow})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      id="nav-constroadmap"
    >
      <HbGuideContainer>
        <h2
          style={{
            color: "white",
            marginBottom: "20px",
            fontSize: "3.8rem",
            textAlign: "center",
          }}
        >
          Download the complete Construction Road Map
        </h2>
        <HbGuideForm name={name} account={account} />
      </HbGuideContainer>
    </HbGuideWrapper>
  );
}

export default HbGuide;
